var map = {
	"./avatar_default.jpeg": 2758,
	"./gruppo_loghi_bianco.png": 2673,
	"./gruppo_loghi_bianco_bk.png": 8648,
	"./gruppo_loghi_nero.png": 3619,
	"./gruppo_loghi_nero_2.png": 2596,
	"./gruppo_loghi_nero_bk3.png": 6820,
	"./gruppo_loghi_nero_bk_2.png": 5393,
	"./gruppo_loghi_nero_bk_origin.png": 8247,
	"./logotipo_orizzontale.png": 977,
	"./logotipo_verticale.png": 1761,
	"./markers/area_default.png": 6017,
	"./markers/area_green.png": 8768,
	"./markers/area_lightblue.png": 710,
	"./markers/area_orange.png": 6181,
	"./markers/area_red.png": 8041,
	"./markers/area_violet.png": 4371,
	"./markers/area_yellow.png": 5992,
	"./markers/marker_default.png": 6639,
	"./markers/marker_green.png": 5249,
	"./markers/marker_lightblue.png": 3216,
	"./markers/marker_orange.png": 5576,
	"./markers/marker_violet.png": 7735,
	"./markers/marker_yellow.png": 6550,
	"./pittogramma.png": 2195,
	"./secesta-viasafe-logo.jpg": 3778,
	"./testo.png": 3771
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;